import axiosInstance from "./axiosInstance";

// Get documents for a specific employee
export const getWorkPlaceTimezone = (companyId, workplaceId) => {
  return axiosInstance.get(
    `https://www.zapendhub.com/api/companies/${companyId}/workplaces/${workplaceId}`
  );
};
